import types from "../types";
import { checkLogin } from "@/api/api";
import { Toast } from "vant";
import WXJsBridge from "@xes/wxjsbridge";

export default {
  state: {
    isLogin: false, // 是否登录
    userId: "", // 用户id
    //存放的键值对就是所要管理的状态
    params: {},
    list: {},
    originParams: {},
    isGoUrl: false,
    isLoad: true, // 是否刷新重新加载接口的标识
    selectAll: true, // 全选按钮状态换课回到续报页面后需要记住
    selectCourseIds: [],
    selectClassIds: [],
    contCourseData: {}, // 续报列表数据
    scrollPosition: 0, // 记录首页滚动位置
    isChangeRawProduct: false, // 是否切换了主商品(主商品切换  需要强制请求加价购的商品  目前这个字段只有这一个作用)
    forcedReload: false, // 是否返回到首页刷新
  },
  mutations: {
    //es6语法，等同edit:funcion(){...}
    setParams(state, params) {
      state.params = params;
    },
    setDataList(state, datalist) {
      state.list = datalist;
    },
    setOriginParams(state, param) {
      state.originParams = param;
    },
    setIsGoUrl(state, param) {
      state.isGoUrl = param;
    },
    setIsLoad(state, param) {
      state.isLoad = param;
    },
    setForcedReload(state, param) {
      state.forcedReload = param;
    },
    [types.SET_ISLOGIN](state, param) {
      state.isLogin = param;
    },
    [types.SET_USERID](state, param) {
      state.userId = param;
      param && sessionStorage.setItem("uid", param); // 用的地方都改成store.userId
    },
    [types.SET_CONT_COURSE](state, param) {
      state.contCourseData = JSON.parse(JSON.stringify(param));
    },
    [types.SET_SELECT_ALL](state, param) {
      state.selectAll = param;
    },
    [types.SET_SELECT_COURSE_IDS](state, param) {
      state.selectCourseIds = param;
    },
    [types.SET_SELECT_CLASS_IDS](state, param) {
      state.selectClassIds = param;
    },
    [types.SET_SCROLL_POSITION](state, param) {
      console.log("执行----SET_SCROLL_POSITION", param);
      state.scrollPosition = param;
    },
    [types.SET_IS_CHANGE_RAW_PRODUCT](state, param) {
      state.isChangeRawProduct = param;
    },
  },
  actions: {
    // 获取登录状态
    async getIsLogin({ commit, dispatch }) {
      try {
        // stat 0 未登录、1 已登录
        const { stat = 0, data = {} } = await checkLogin();
        commit(types.SET_ISLOGIN, true);
        if (+stat === 1) {
          commit(types.SET_ISLOGIN, true);
          commit(types.SET_USERID, data?.user_id || "");
          return !!stat; // 0 未登录、1 已登录
        } else {
          commit(types.SET_ISLOGIN, false);
          await dispatch("handleLogin", {
            login: !!stat,
          });
          return !!stat;
        }
      } catch (err) {
        Toast.fail("网络或服务异常~");
        console.log("网络请求错误：", err);
      }
    },
    // 处理登录 【端上 / h5】
    async handleLogin({ commit, dispatch }, params) {
      // 如果APP内
      if (this.$isInApp) {
        try {
          if (params?.login) {
            this.$nextTick(() => {
              // 页面重新出现时
              window.webOnResume = () => {
                // 处理逻辑
                location.reload();
              };
              window.location.href = "xeswangxiao://xrsApp?m=personals/setting";
            });
          } else {
            WXJsBridge.openLoginPage(
              {
                // autoReload  登录后是否需要自动刷新 0否 1是(默认)
              },
              async (err, res) => {
                if (+res?.status === 1) {
                  commit(types.SET_ISLOGIN, true);
                }
              }
            );
          }
        } catch (error) {
          alert(error.message);
        }
      } else {
        // 见 https://wiki.zhiyinlou.com/pages/viewpage.action?pageId=164883089
        const currentURL = encodeURIComponent(window.location.href);
        window.location.href = `https://login.xueersi.com/?redirect_url=${currentURL}`;
      }
    },
  },
};
